import { Form, Select, Tag } from "antd";
import { useState } from "react";

export const FilterCountBubble = ({countToShow}) => {
    return (<>
        <div
            style={{
                position: 'absolute',
                top: -5,
                right: -5,
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '50%',
                width: 18,
                height: 18,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                zIndex: 2,
                padding:'5px'
            }}
        >
            +{countToShow}
        </div>
    </>)
}

export const MultipleSelectWithCount = ({ name, placeholder, options = [], width = 120, maxTagCount = 1, 
  dropdownMatchSelectWidth= 200, onSearch = null, onChange = null
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (<>
    <Form.Item shouldUpdate>
      {({ getFieldValue }) => {
        const selected = getFieldValue(name) || [];
        return (
          <div style={{ position: 'relative', width: width }}>
            <Form.Item name={name} noStyle>
              <Select
                mode="multiple"
                allowClear
                placeholder={placeholder}
                style={{ width: '100%' }}
                maxTagCount={maxTagCount}
                dropdownMatchSelectWidth={dropdownMatchSelectWidth}
                open={dropdownOpen}
                onSearch={(inputValue) => onSearch ? onSearch(inputValue) : {}}
                onChange={(inputValue) => onChange ? onChange({[name]:inputValue}) : {}}
                // onDropdownVisibleChange={(open) => (!open && selected?.length === 1) ? options?.length > 1 ? setDropdownOpen(true) : setDropdownOpen(false) : setDropdownOpen(open)}
                onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onBlur={()=>{
                  setTimeout(()=>{
                    if(selected?.length === 1){
                      if(options?.length > 1){
                        setDropdownOpen(true)
                      }else{
                        setDropdownOpen(false)
                      }
                    }else{
                      setDropdownOpen(false)
                    }
                  },10)
                }}
              >
                {options?.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {selected.length > 1 && (
              <FilterCountBubble countToShow={selected.length - 1} />
            )}
          </div>
        );
      }}
    </Form.Item>
  </>)
}

export const removeCurrentTag = (tagKeyToRemove, idToRemove, updatedFilters, form, multipleFilterKeys, multipleKeysToSetAgain) => {
  if (!updatedFilters) return {};

  const currentValue = updatedFilters[tagKeyToRemove];

  if (multipleFilterKeys.includes(tagKeyToRemove) && currentValue && typeof currentValue === 'string') {
    const currentAppliedFilters = currentValue.split(',');
    const newValues = currentAppliedFilters.filter(val => val !== idToRemove);

    if (newValues.length === 0) {
      delete updatedFilters[tagKeyToRemove];
      form.resetFields([tagKeyToRemove]);
    } else {
      updatedFilters[tagKeyToRemove] = newValues.join(',');
      form.setFieldsValue({ 
        [tagKeyToRemove]: multipleKeysToSetAgain.includes(tagKeyToRemove) ?  // multipleKeysToSetAgain this is to set the ids of the remaining selected ids in the select field again 
          newValues.map((i)=>parseInt(i))
          : newValues
      });
    }
  } else {
    delete updatedFilters[tagKeyToRemove];
    form.resetFields([tagKeyToRemove]);
  }

  return updatedFilters || {};
};

export const renderTagsForKey = (tagKey, tagConfig, filters, onRemoveFiltersByTag) => {
  const renderFilterTag = (valueToDisplay, tagKey, value) => {
    return (
      <Tag
        closable 
        className="filter-tag"
        onClose={() => value ? onRemoveFiltersByTag(tagKey, value) : onRemoveFiltersByTag(tagKey)} 
        style={{ border: "0.5px solid #038fde" }} 
        key={tagKey}
      >
        {valueToDisplay}
      </Tag>
    )
  }

  const value = filters[tagKey];
  if (value === undefined || value === null || value === '') return null;

  const config = tagConfig[tagKey] || { label: tagKey };
  console.log('config',config)
  const { customRender, data, idField = 'value', displayField = 'name' } = config;

  // Static or custom-render fields
  if (!data) {
    const valueArray = typeof value === 'string' ? value.split(',') : value;
    const values = Array.isArray(valueArray) ? valueArray : [valueArray];

    return values.map((val) => (
      renderFilterTag((customRender ? customRender(val) : val), tagKey, val)
    ));
  }

  // Mapped fields (like dropdowns)
  const valueArray = typeof value === 'string' ? value.split(',') : value;
  if (!Array.isArray(valueArray) || valueArray.length === 0) return null;

  return valueArray.map((val) => {
    const matched = data.find((item) =>
      item[idField]?.toString() === val?.toString()
    );
    if (!matched) return null;
    return (
      renderFilterTag((matched[displayField]), tagKey, val)
    );
  });
};
